/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-12-23 09:57:50
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2026-03-30 19:26:07
 * @FilePath: /designcenter/src/store/header.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { defineStore } from 'pinia'

interface Obj {
  [key: string]: unknown
  type?: string
  templateId?: string | number
  tempTypeId?: string | number
  projectId?: string | number | null
  projectName?: string
}

// 选中的模板数据类型
export interface SelectedTemplateData {
  id: number
  typeId: number
  name?: string
  description?: string
  picUrl?: string
}

interface HeaderState {
  show_create_project_popup: boolean
  select_template_popup: boolean
  select_template_from_use_template: boolean // 标识是否从 "Use a template" 按钮打开
  select_template_popup_refresh_key: number
  show_feedback_popup: boolean
  guide_debug_trigger_key: number
  createProjectPramas: Obj | null
  // 从 "Use a template" 选中的模板数据，用于触发 designCenter 的弹窗
  selected_template_for_use: SelectedTemplateData | null
}

export const useHeaderStore = defineStore('header', {
  state: (): HeaderState => ({
    show_create_project_popup: false,
    select_template_popup: false,
    select_template_from_use_template: false,
    select_template_popup_refresh_key: 0,
    show_feedback_popup: false,
    guide_debug_trigger_key: 0,
    createProjectPramas: null,
    selected_template_for_use: null,
  }),
  getters: {},
  actions: {
    showCreateProjectPopup(payload?: Obj) {
      if (payload) {
        this.createProjectPramas = payload
      }
      this.show_create_project_popup = true
    },
    hideCreateProjectPopup() {
      this.show_create_project_popup = false
      this.createProjectPramas = null
    },
    showSelectTemplatePopup(fromUseTemplate = false) {
      this.select_template_popup = true
      this.select_template_from_use_template = fromUseTemplate
      this.select_template_popup_refresh_key += 1
    },
    hideSelectTemplatePopup() {
      this.select_template_popup = false
      this.select_template_from_use_template = false
    },
    showFeedbackPopup() {
      this.show_feedback_popup = true
    },
    hideFeedbackPopup() {
      this.show_feedback_popup = false
    },
    triggerGuideDebug() {
      this.guide_debug_trigger_key += 1
    },
    // 设置从 "Use a template" 选中的模板数据
    setSelectedTemplateForUse(templateData: SelectedTemplateData | null) {
      this.selected_template_for_use = templateData
    },
    // 清除选中的模板数据
    clearSelectedTemplateForUse() {
      this.selected_template_for_use = null
    },
  },
})
